import { render } from "./ControlSidebar.vue?vue&type=template&id=c56a72ce"
import script from "./ControlSidebar.vue?vue&type=script&lang=js"
export * from "./ControlSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/corfits.id/e-budgeting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__